import React from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { theme } from 'styled-tools';
import SeoContentHomePage39 from './SeoContentHomePage39';
import SeoContentHomePage47 from './SeoContentHomePage47';
import SeoContentHomePage46 from './SeoContentHomePage46';
import SeoContentHomePage61 from './SeoContentHomePage61';
import { Link } from 'react-router-dom';
import SeoContentHomePage33 from './SeoContentHomePage33';
import { getDamain } from 'src/util/commonfun';
import SeoContentHomePage32 from './SeoContentHomePage32';

function SeoContentHomePage(props) {
    const { app: {
        brandId
    }, theme: { config } } = props;
    const { showSeoFooterInsidePages } = config

    let domainURL = getDamain(brandId);
    const domainName = brandId === 31 || brandId === 32 ? 'Yolo247' : brandId === 33 ? 'IW247' : (brandId === 39 || brandId === 40) ? 'FOMO7' : (brandId === 46 || brandId === 47) ? 'Fun88' : 'Betdaily';

    return (
        <>
            {(brandId == 39 || brandId == 40) ? <SeoContentHomePage39 />  
            : brandId == 46 ? <SeoContentHomePage46 /> 
            : brandId == 47 ? <SeoContentHomePage47 /> 
            : brandId == 61 ? <SeoContentHomePage61 /> 
            : brandId == 33 ? <SeoContentHomePage33 /> 
            : brandId == 32 ? <SeoContentHomePage32 /> 
            : (
                <AccordionWrapper>
                    <Accordion>
                        <input type="checkbox" id="section1" className="accordion__input" />
                        <label htmlFor="section1" className="accordion__label"><h1>{brandId == 32 ? "Online Betting ID in India" : (brandId == 39 || brandId == 40) ? "Best Site for Online Betting in India | Explore Sports & Casino" : "Your Go‑To for Sports Betting & Online Casino in India"}</h1></label>
                        {(brandId == 39 || brandId == 40) ? <SeoContentHomePage39 /> : (
                              <div className="accordion__content">
                <h2>Yolo247: Your Ultimate Betting Partner</h2>
                <p>Experience the thrill of <Link to="/">sports betting & online casino</Link> in India with Yolo247. This is the site to feel like you are right in the middle of the action! From betting on your favorite sports team to trying your hand at poker, the options are endless.</p>

                <h2>Why Yolo247?</h2>
                <p>The Yolo247 site is the absolute gold standard in online gaming platforms. Here is a peek at the features that make it the perfect betting partner for you:</p>
                <ul>
                    <li><strong>Impressive casino catalog:</strong> choose from hundreds of <Link to="/instant-games">instant</Link>, <Link to="/slots">slot</Link>, and <Link to="/live-casino
">live casino</Link> games</li>
                    <li><strong>Global sports:</strong> the best sports betting in India for cricket, tennis, football, and more.</li>
                    <li><strong>Multiple sports betting options:</strong> place straight, live, fancy bets, and more.</li>
                    <li><strong>Unbeatable bonuses:</strong> enjoy <Link to="/promotions/welcome-bonus">welcome</Link>, <Link to="/promotions/cashback-bonus">cashback</Link>, <Link to="/promotions/refill-bonus
">refill</Link>, and <Link to="/promotions/referral-bonus">referral bonuses</Link></li>
                    <li><strong>Instant withdrawals:</strong> online casino offers instant access to winnings.</li>
                    <li><strong>Diverse payment options:</strong> choose from credit/debit cards, UPI, internet banking, and e-wallets.</li>
                    <li><strong>Mobile gaming:</strong> play games and place bets on your Android device.</li>
                    <li><strong>Fair play:</strong> guaranteed unbiased play for sports betting and casino games.</li>
                    <li><strong>24/7 customer support:</strong> get instant acgicess to <a href="https://yolo247.site/help/customer-care/
">customer service</a> whenever you play.</li>
                </ul>

                <h2>How to Join Yolo247?</h2>
                <p>Here is a quick and simple guide to <Link to="/signup">sign up with Yolo247</Link>:</p>
                <ol>
                    <li>Visit the Yolo247 site.</li>
                    <li>Click on the <Link to="/signup
">Sign Up</Link> button.</li>
                    <li>Create a username, password, and enter your mobile number.</li>
                    <li>Submit the OTP, and fill in the remaining details.</li>
                </ol>
                <p>Well, what are you waiting for? You are only a few steps away from joining the best sports betting & online casino in India. Sign up today and start winning big! </p>

                <h2>Explore Live Casino Games and Sports Betting Markets</h2>
                <p>Yolo247 has a wide variety of <Link to="/live-casino">casino games</Link> and <Link to="/betting-exchange?id=0">sports betting</Link> options for you! Here is a sneak peek at what this site has in store for you:</p>

                <h3>Instant Casino Games</h3>
                <p>These casino games are quick, easy to play, and perfect for beginners. The good news is that the <Link to="/instant-games">instant games</Link> can still offer some pretty great winnings! Some of the favorites include: </p>
                <ul>
                    <li><Link to="/instant-games/spribe/aviator">Aviator</Link></li>
                    <li><Link to="/instant-games/spribe/plinko">Plinko</Link></li>
                    <li><Link to="/instant-games/spribe/hilo">HiLo</Link></li>
                    <li><Link to="/instant-games/spribe/keno">Keno</Link></li>
                </ul>

                <h3>Slot Casino Games</h3>
                <p>These <Link to="/slots
">slot casino games</Link> offer gorgeous graphics and impressive payouts. Here are some of the more popular games:</p>
                <ul>
                    <li><Link to="/slots/netent/dead-or-alive
">Dead or Alive</Link></li>
                    <li><Link to="/slots/netent/fruit-shop
">Fruit Shop</Link></li>
                    <li><Link to="/slots/netent/aloha-christmas
">Aloha</Link></li>
                    <li><Link to="/slots/netent/baccarat
">Baccarat</Link></li>
                </ul>

                <h3>Live Casino Games</h3>
                <p>The live games are just what you need for an authentic casino experience. Live dealers add an extra layer of fun to this real money <strong>online casino</strong>. Here are the games you are sure to love: </p>
                <ul>
                    <li><Link to="/live-casino/live-blackjack">Blackjack</Link></li>
                    <li><Link to="/live-casino/teen-patti
">TeenPatti</Link></li>
                    <li><Link to="/live-casino/evolution/lightning-dice
">Lightning Dice</Link></li>
                    <li><Link to="/live-casino/live-roulette">Roulette</Link></li>
                </ul>

                <h3>Sports Betting</h3>
                <p>As a leading sports betting platform, Yolo247 knows what its players need! You can bet on cricket, football, tennis, and virtual sports, all with competitive odds.</p>
                <p>Your sports betting options include:</p>
                <ul>
                    <li><Link to="/betting-exchange
">Exchange</Link></li>
                    <li><Link to="/sportsbook">Sportsbook</Link></li>
                    <li><Link to="/premium-sportsbook">Premium Sportsbook</Link></li>
                </ul>

                <h2>Yolo247 Sports Betting Experience</h2>
                <p>Yolo247 is the top real money sports betting platform. Players can enjoy an immersive experience for major tournaments and smaller events. Your experience is improved even further with competitive odds and fast withdrawals. </p>

                <h2>Extensive Sports Betting Markets</h2>
                <p>Yolo247 covers a wide range of betting markets. This includes cricket, football, basketball, tennis, and more. You can even <Link to="/virtualSports/vci"><a><strong>bet on virtual cricket</strong></a></Link> on the site. The betting exchange gives you variety with pre-match and live betting options. Players get real-time updates, allowing them to make bets even while the action is going on!</p>

                <h2>Varied Betting Providers</h2>
                <p>Here are some of the betting providers you can find on Yolo247:</p>
                <ul>
                    <li><strong><Link to="/betting-exchange
">Betting Exchange</Link></strong></li>
                    <li><strong><Link to="/sportsbook
">Sportsbook</Link></strong></li>
                    <li><strong><Link to="/premium-sportsbook
">Premium Sportsbook</Link></strong></li>
                    <li><Link to="/saba-sports">SABA Sports</Link></li>
                </ul>

                <h2>Popular Sports and Tournaments</h2>
                <p>You can find any event or tournament for various sports on this <strong>betting exchange</strong>. Cricket fans can bet on major tournaments. This includes the IPL, Big Bash, and international series. Football lovers will find options like the Premier League and the FIFA World Cup.</p>

                <h2>Best Sports Betting Odds India</h2>
                <p>It doesn't matter if you're looking for <Link to="/betting-exchange/football-betting
">football</Link> or <Link to="/betting-exchange/online-cricket-betting">cricket betting odds</Link> India. Yolo247 is going to offer you some of the most competitive odds on the market. And, this isn't just for minor events either. You will find some of the best <strong><a href="https://yolo247.site/sports/tournaments/ipl-betting
">IPL betting odds</a></strong> on this site.</p>

                <h2>Diverse Betting Types</h2>
                <p>Yolo247 supports various bet types, including:</p>
                <ul>
                    <li>Straight Bet</li>
                    <li>Parlay Bet</li>
                    <li>Over/Under Bet</li>
                    <li>Future Bet</li>
                    <li><a href="https://yolo247.site/blog/prop-bets-a-detailed-guide/">Prop Bet</a></li>
                    <li>Spread Bet</li>
                    <li>Multi Bet</li>
                </ul>

                <h2>Why Bet on Yolo247?</h2>
                <ul>
                    <li>Competitive betting odds</li>
                    <li>Low deposit options</li>
                    <li>Attractive bonuses and promotions for both new and regular players</li>
                </ul>
                <p>If you are ready to enjoy all that Yolo247 has to offer, it is time to place your first sports bet! </p>

                <h2>Yolo247 Online Casino & Table Games</h2>
                <p>Yolo247 is the site for you if you want variety and great odds. Discover slot games, instant games, and live casino games on the platform. Whether you want a strategic game or quick thrills, your match awaits you!</p>

                <h2>The Casino Games of Yolo247</h2>
                <p>Let's discover more about the many online casino games Yolo247 has in store!</p>

                <h2>Game Categories</h2>
                <p>In a real casino, you can find all types of betting games. And that's exactly the variety you can expect on this online casino platform.</p>
                <ul>
                    <li>Card and table games</li>
                    <li>Crash games</li>
                    <li><a href="https://yolo247.site/blog/casino-dice-game/
">Dice games</a></li>
                    <li><Link to="/slots">Slot games</Link></li>
                    <li>Wheel games</li>
                </ul>
                <p>Check out each category - you can never tell when you'll come across your favourite game! </p>

                <h2>Popular Game Providers</h2>
                <p>Here are some of the casino game providers that develop some of the hottest titles on Yolo247:</p>
                <ul>
                    <li><Link to="/instant-games/turbo-games">Turbo Games</Link></li>
                    <li><Link to="/live-casino/evolution">Evolution Gaming</Link></li>
                    <li><Link to="/instant-games/spribe
">Spribe</Link></li>
                    <li><Link to="/instant-games/aviatrix">Aviatrix</Link></li>
                    <li><Link to="/instant-games/betgames
">BetGames</Link></li>
                </ul>

                <h2>The Most Popular Games</h2>
                <p>Discover the games that our players can't get enough of! These game titles may just get you hooked, too! </p>

                <h3>Instant Games</h3>
                <ul>
                    <li><strong><Link to="/instant-games/spribe/aviator
">Aviator</Link></strong></li>
                    <li><strong><Link to="/instant-games/aviatrix
">Aviatrix</Link></strong></li>
                    <li><Link to="/instant-games/smartsoft/jetx">JetX</Link></li>
                </ul>

                <h3>Live Casino Games</h3>
                <p>The <strong>live casino</strong> games that are most popular among players include:</p>
                <ul>
                    <li><strong><Link to="/live-casino/live-roulette
">Roulette</Link></strong></li>
                    <li><strong><Link to="/live-casino/live-blackjack">Blackjack</Link></strong></li>
                    <li><strong><Link to="/live-casino/live-baccarat">Baccarat</Link></strong></li>
                    <li><Link to="/live-casino/dragon-tiger">Dragon Tiger games</Link></li>
                </ul>
                <p>Take these games out for a spin and discover just how fun they can be! </p>

                <h2>How to Play Guides</h2>
                <p>Curious how to play some of the top-rated games on the site? Here is a list of guides that will show you how to get a running start:</p>
                <ul>
                    <li><a href="https://www.yolo247.site/blog/how-to-play-take-my-plinko"><strong>How to play Take My Plinko</strong></a></li>
                    <li><a href="https://www.yolo247.site/blog/how-to-play-dragon-tiger-game/"><strong>How to play Dragon Tiger Game</strong></a></li>
                    <li><a href="https://www.yolo247.site/blog/andar-bahar-game/"><strong>How to play Andar Bahar game</strong></a></li>
                    <li><a href="https://www.yolo247.site/blog/how-to-play-worli-matka/"><strong>How to play Worli Matka</strong></a></li>
                    <li><a href="https://www.yolo247.site/blog/how-to-play-aviator-game/"><strong>How to play Aviator game</strong></a></li>
                    <li><a href="https://www.yolo247.site/blog/red-door-roulette-game/"><strong>How to play Red Door roulette game</strong></a></li>
                    <li><a href="https://www.yolo247.site/blog/how-to-play-jetx/"><strong>How to play JetX</strong></a></li>
                    <li><a href="https://www.yolo247.site/blog/how-to-play-crash-x/"><strong>How to play Crash X</strong></a></li>
                    <li><a href="https://www.yolo247.site/blog/how-to-play-teen-patti-game/"><strong>How to play Teen Patti</strong></a></li>
                    <li><a href="https://www.yolo247.site/blog/how-to-play-dice-game/"><strong>How to play Dice Game</strong></a></li>
                </ul>

                <h2>Why Play Casino Games on Yolo247?</h2>
                <p>Why wouldn't you want to play casino games on Yolo247 when you get to enjoy these benefits?</p>
                <ul>
                    <li>Play online casino games for real money</li>
                    <li>High casino payout odds</li>
                    <li>Demo versions to hone your game</li>
                    <li>Bonuses and promotions that boost your playing time</li>
                </ul>

                <h2>Yolo247 Bonuses & Promotions</h2>
                <p>Good news for gamers: Yolo247 offers the best online casino bonuses in India! The more bonus money you get, the more you can play and win.</p>
                <p>Here are the Yolo247 bonuses that will boost your playing time:</p>

                <h3>Welcome Bonus</h3>
                <p>The online casino <Link to="/promotions/welcome-bonus">Welcome Bonus</Link> is for new players signing up with Yolo247. But, don't delay! The 400% bonus is only available if you sign up within the first 30 minutes.</p>
                <p>If you miss this window, your bonus shrinks to 300%.</p>

                <h3>Refill Bonus</h3>
                <p>Do you know that Yolo247 is the only platform in India offering players a bonus with every new deposit? And all you have to do is top up your account!</p>
                <p>You then automatically earn a <Link to="/promotions/refill-bonus">refill bonus</Link> of up to 4%.</p>

                <h3>Cashback Bonus </h3>
                <p>Feel like you have been spending more than you have been winning? Well, that's not a problem thanks to the <Link to="/promotions/cashback-bonus">cashback bonus!</Link></p>
                <p>Get up to 4% back on the money you have lost during the week.</p>

                <h3>Referral Bonus</h3>
                <p>Invite your friends to join in on the action at Yolo247! With the <Link to="/promotions/referral-bonus">referral bonus</Link>, you reap the rewards of your friends signing up.</p>
                <p>You get paid for your friend's first three deposits. Receive a bonus of up to 20% every time they top up their account. </p>

                <p>With bonuses like this, how can you resist joining Yolo247? Sign up now and enjoy these promotions! </p>

                <h2>Loyalty Program</h2>
                <p>The <Link to="/loyalty">Yolo247 loyalty</Link> program is all about rewarding our dedicated players. We have five tiers in our program: Blue, Silver, Gold, Platinum, and Elite.</p>
                <p>Check out some of the cool features for each tier: </p>

                <h3>Blue</h3>
                <ol>
                    <li>1% bonus on every redeposit.</li>
                    <li>1% cashback bonus on weekly losses.</li>
                    <li>No minimum turnover amount required.</li>
                </ol>

                <h3>Silver</h3>
                <ol>
                    <li>2% bonus on every redeposit.</li>
                    <li>2% cashback bonus on weekly losses.</li>
                    <li>A 25-lakh per month turnover requirement.</li>
                </ol>

                <h3>Gold</h3>
                <ol>
                    <li>3% bonus on every redeposit.</li>
                    <li>3% cashback bonus on weekly losses.</li>
                    <li>40-lakh per month turnover amount required for the Gold tier.</li>
                </ol>

                <h3>Platinum</h3>
                <ol>
                    <li>4% bonus on every redeposit.</li>
                    <li>4% cashback bonus on weekly losses.</li>
                    <li>1 crore per month turnover amount is required for the Platinum tier.</li>
                </ol>

                <h3>Elite</h3>
                <ol>
                    <li>You can get into this tier by invitation only.</li>
                    <li>Elite user's terms will be discussed by their respective relationship managers.</li>
                </ol>

                <h2>Get Started With Yolo247</h2>
                <p>We want to make it easy for you to <Link to="/signup
">sign up</Link> with Yolo247. This is why the process takes just a few minutes. You will be free to move on to sports betting or playing casino games in no time at all!</p>

                <h2>Yolo247 Desktop Version</h2>
                <p>The Yolo247 desktop site is perfect if you want a big screen to play games or place a sports bet. Visit the Yolo247 site, log in to your account, and start playing.</p>

                <h2>Yolo247 App</h2>
                <p>Bet on your favorite sport or play a casino game even while you are on the go! <Link to="/app-download">Download Yolo247 app</Link> and enjoy an immersive experience on your smartphone. All you need to play is a stable internet connection.</p>

                <p>How to Create Your Account on Yolo247</p>
                <p>Follow these steps to create your very own account:</p>
                <ul>
                    <li>Step 1: Click on the <strong>Sign Up</strong> button located in the top right corner of the Yolo247 site.</li>
                    <li>Step 2: Enter a username and password for your new account.</li>
                    <li>Step 3: Enter your mobile number.</li>
                    <li>Step 4: Wait for an OTP and continue with the signup process. </li>
                </ul>

                <h2>Bet Anytime, Anywhere - Download the Yolo247 App Now!</h2>
                <p>A growing number of players in India are taking a mobile-first approach to gaming. This is why we created the <Link to="/app-download
">Yolo247 app</Link>. Enjoy constant access, no matter where you are!</p>
                <p>As the best live casino app in India, you can play any casino game on the Yolo247 mobile version. All the games are mobile-friendly, making them a dream to play on your smartphone.</p>
                <p>The Yolo247 app is also the top sports betting app India. Place bets on cricket, tennis, football, basketball, and more</p>

                <h2>How to Download the Yolo247 App</h2>
                <p>The Yolo247 app is free for Android devices. The app is available in Hindi and English. Follow these steps to download the app:</p>
                <ul>
                    <li><strong>Step 1</strong>: Visit the Yolo247 site on your smartphone.</li>
                    <li><strong>Step 2</strong>: Click on the Menu Button</li>
                    <li><strong>Step 3</strong>: Click on "Download Android App"</li>
                    <li><strong>Step 4</strong>: Let the app download</li>
                    <li><strong>Step 5</strong>: Install the Yolo247 app on your phone</li>
                </ul>
                <p>OR</p>
                <ul>
                    <li><strong>Step 1</strong>: Visit the Yolo247 site on your desktop.</li>
                    <li><strong>Step 2</strong>: Click on the <a href="https://getapp.yoloappnow.com/yolo247.apk">"Download Now"</a> button in the top right corner of the site.</li>
                    <li><strong>Step 3</strong>: Scan the QR code to download the app.</li>
                    <li><strong>Step 4</strong>: Install the Yolo247 app on your phone.</li>
                </ul>

                <h2>Yolo247 App Features</h2>
                <p>Here are some of the features you can enjoy with the Yolo247 app:</p>
                <ul>
                    <li>The app is completely free to use</li>
                    <li>Access to mobile versions of casino games and betting exchanges</li>
                    <li>Seamless, single-finger navigation</li>
                    <li>Quick load time</li>
                    <li>Excellent security features</li>
                    <li>24/7 customer support team</li>
                </ul>

                <h2>Yolo247 App Benefits</h2>
                <p>There are plenty of advantages to using the Yolo247 app:</p>
                <ul>
                    <li>The app loads more quickly and requires less data</li>
                    <li>Simple and user-friendly interface</li>
                    <li>Promotions and bonuses tailored to the app</li>
                    <li>The desktop and mobile data are automatically synchronized</li>
                </ul>

                <h2>Yolo247 Safe & Secure Payments</h2>
                <p>When you <strong><Link to="/signup">sign up</Link></strong> and bet on Yolo247, you are guaranteed simple deposits and withdrawals. You can choose from a variety of Yolo247 payment methods. These include Regular UPI, Net Banking, and Fast Crypto.</p>

                <h3>How to Deposit at Yolo247</h3>
                <p>Here is a quick guide on how to make deposits on the site:</p>
                <ol>
                    <li>Click on the "Deposit" button</li>
                    <li>Click on your desired payment method</li>
                    <li>Enter your deposit amount</li>
                    <li>Choose your channel</li>
                    <li>Submit the details</li>
                    <li>Enter payment details in the next page</li>
                </ol>

                <h3>How to Withdraw at Yolo247</h3>
                <p>Follow these steps to withdraw your money:</p>
                <ol>
                    <li>Click on the dropdown menu next to your username</li>
                    <li>Go to Finances</li>
                    <li>Click on the Withdrawal section</li>
                    <li>Enter bank details</li>
                    <li>Click on Instant Withdrawal or Crypto Withdrawal </li>
                </ol>

                <h2>Online Betting Tips & News</h2>
                <p>At Yolo247, we want to give you the best possible chance to win. This is why we have the Yolo247 blogs! Our blogs contain:</p>
                <ul>
                    <li>How to play <a href="https://www.yolo247.site/blog/"><strong>guides</strong></a></li>
                    <li>IPL News and Records</li>
                    <li>Tennis betting tips</li>
                </ul>
                <p>Beginners and pros alike will benefit from the expert advice. Check out the top tips and tricks today to discover how you can improve your game. </p>

                <h2>Responsible Gambling</h2>
                <p>We want to ensure that all our players engage in responsible gambling. At Yolo247, we only allow adults above the age of 18 to create an account and use the site. We have guidelines that players can follow to manage their gambling.</p>
                <p>If you struggle with gambling, we are here to support you. You can contact our customer service to put self-exclusionary practice into effect. </p>

                <h2>Frequently Asked Questions </h2>
                <ul>
                    <li>
                        <h3>Which is the best online casino in India?</h3>
                        <p>Yolo247 is the best online casino in India. This is due to its variety in games and betting options, excellent odds, and easy payment options.</p>
                    </li>
                    <li>
                        <h3>Which are some of the most popular online casino games on Yolo247?</h3>
                        <p>Some of the most popular games are Aviator, Mines, Crazy Time, and Lightning Roulette.</p>
                    </li>
                    <li>
                        <h3>How do I deposit and withdraw money on Yolo247?</h3>
                        <p>Click on the deposit button on the site. Use the banking options on the page to either add or withdraw funds.</p>
                    </li>
                    <li>
                        <h3>Can I play sports betting and casino games on mobile?</h3>
                        <p>Yes, you can. You can do this through the Yolo247 app, which can be downloaded onto any Android device. </p>
                    </li>
                </ul>
            </div>
                        )}
                    </Accordion>
                </AccordionWrapper>
            )}
        </>
    )
}

export default withTheme(withAppContext(SeoContentHomePage))

//Styled Components
export const Accordion = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    color: ${theme('palette.seoContenAccordionHeadTextColor')};
    background: ${theme('palette.seoContenAccordionHeadBg')};

    .accordion__label, .accordion__content {
        padding: 14px 20px;
    }

    h1 {
        display: block;
        font-size: 1em;
        font-weight: bold;
        margin: 0;
    }

    h2 {
        display: block;
        font-size: 1.5em;
        font-weight: bold;
        color: ${theme('palette.seoContenAccordionHeadTextColor')};
    }

    h3 {
        display: block;
        font-size: 1.1em;
        font-weight: bold;
    }

    h5 {
        display: block;
        font-size: 0.9em;
        font-weight: bold;
    }

    .number {
        list-style: number;

        li {
            font-weight: bold;
        }
    }

    ul {
        li {
            font-size: 0.91em;
        }
    }

    .fontBold {
        li {
            font-size: 1em;
            font-weight: bold;
        }
    }

    .bgTheme {
        padding: 1rem;
        padding-left: 2rem;
        border-radius: 5px;
        background: ${theme('palette.seoContenAccordionInnerULtextBgTheme')};
    }

    p {
        margin: 5px 0 10px 0;
        color: ${theme('palette.seoContenAccordionInnerTextColor')};
        font-size: 0.91em;
        font-weight: normal;
        text-transform: none;
    }

    ol, ul {
        li {
            text-transform: none;
            font-size: 0.91em;
        }
    }

    a {
        /* color: #f4a322; */
        color: ${theme('palette.seoContenAccordionInnerAngerTagColor')};
    }

    .underLine {
        text-decoration: underline;

        :hover {
            color: #fff;
        }
    }

    .linkBg {
        display: flex;
        align-items: center;
        justify-content: left;
        flex-wrap: wrap;
        gap: 5px;

        a {
            background: ${theme('palette.seoContenAccordionLinkBgColor')};
            border-radius: 5px;
            padding: 5px 10px;
        }
    }

    .textTransformNone {
        text-transform: none;
    }

    .accordion__label{
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${theme('palette.seoContenAccordionHeadTextColor')};
        padding: 20px;
        background: ${theme('palette.seoContenAccordionHeadBg')};
        text-align: center;
        position: relative;
        cursor: pointer;

        :after {
            content: "";
            display: inline-block;
            border-style: solid;
            border-color: ${theme('palette.seoContenAccordionArrowBorder')};
            border-width: 0 2px 2px 0;
            padding: 2.5px;
            vertical-align: middle;
            transition: transform 0.3s;
            /* transform: rotate(225deg); */
            transform: ${theme('palette.seoContenAccordionArrowMarkAfter')};
            position: absolute;
            right: 20px;
        }
    }

    .accordion__label:hover{
        background: ${theme('palette.seoContenAccordionHeadHoverBg')};
    }

    .accordion__content {
        background: ${theme('palette.seoContenAccordionContentBg')};
        line-height: 1.6;
        font-size: 0.85em;
        opacity: ${theme('palette.seoContenAccordionContentOpacityOpen')};
        text-transform: capitalize;
        max-height: ${theme('palette.seoContenAccordionContentMaxHeightOpen')};
        padding: ${theme('palette.seoContenAccordionContentPaddingOpen')};
        margin: ${theme('palette.seoContenAccordionContentMarginOpen')};
        overflow-x: ${theme('palette.seoContenAccordionContentOverFlowXOpen')};
        overflow-y: ${theme('palette.seoContenAccordionContentOverFlowYOpen')};
        transition: 0.3s;

        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
            background-color: #f5f5f5;
            border-radius: 10px;
        }

        &::-webkit-scrollbar {
          width: 10px;
          background-color: #f5f5f5;
        }
    
        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background:gray;
          margin-bottom: 10px;
        }
    }

    .accordion__input {
        display: none;
    }

    .accordion__input:checked ~ .accordion__content {
        opacity: ${theme('palette.seoContenAccordionContentOpacityClosed')};
        max-height: ${theme('palette.seoContenAccordionContentMaxHeightClosed')};
        padding: ${theme('palette.seoContenAccordionContentPaddingClosed')};
        margin: ${theme('palette.seoContenAccordionContentMarginClosed')};
    }

    .accordion__input:checked ~ .accordion__label:after {
        transform: ${theme('palette.seoContenAccordionArrowMarkBefore')};
    }

    .td,th{
        border: 1px solid white;
    }
  
    .table, th, td {
  border: 1px solid white;
  border-collapse: collapse;
}

    .italic {
        font-style: italic;
    }

`;

export const AccordionWrapper = styled.div`
    width: 100%;
  table,th,td{
    border: 1px solid white;
  }

  .lineDash {
    width: 100%;
    height: 1px;
    border: 1px solid #fff;
    border: dashed 1px #4c4c4c;
    border-width: 1px;
    }
`;